




















import {Component, Prop, Vue} from "vue-property-decorator";
import ImageText from "./ImageText.vue";

@Component({
  components: {
    ImageText
  }
})

export default class ImageGrid extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  @Prop() item;
}
